import { useContext } from 'react'
import DeepAnalysisSectionHeader from './DeepAnalysisSectionHeader'
import DeepAnalysisComparePanes from './DeepAnalysisComparePanes'
import DeepAnalysisPeriodContext from '../../StateManagment/DeepAnalysisPeriodContext'

/**
 * "Deelname" section of a deep-analysis page (redesign). The body is a slot —
 * the indicator data layer portals the answers-per-week chart plus the totals
 * column into it via DeepAnalysisSlotsContext, so the data fetching stays
 * where it is (same source as the old info-popover content).
 *
 * When the page compares two periods it offers a labelled body per period,
 * so the two copies of the result card don't share one chart area.
 * AI-CONTEXT: See docs/features/deep-analysis-period.md
 *
 * @param {object} props
 * @param {(el: HTMLElement|null) => void} props.setParticipationEl - Ref callback registering the body as portal target
 * @param {(el: HTMLElement|null) => void} [props.setParticipationElB] - Ref callback for the compare period's body
 */
const DeepAnalysisParticipationSection = ({ setParticipationEl, setParticipationElB }) => {
    const period = useContext(DeepAnalysisPeriodContext)
    const compare = Boolean(period?.compareActive && setParticipationElB)

    return (
        <div className='deep-analysis-section'>
            <DeepAnalysisSectionHeader
                kicker='Deelname'
                title='Antwoorden per week'
                description='Hoeveel antwoorden er per week zijn binnengekomen. Geeft context bij de betrouwbaarheid van het resultaat.'
            />
            {compare ? (
                <DeepAnalysisComparePanes
                    rangeA={period.rangeA}
                    rangeB={period.rangeB}
                    setElA={setParticipationEl}
                    setElB={setParticipationElB}
                    paneClassName='deep-analysis-participation-slot'
                />
            ) : (
                <div className='deep-analysis-participation-slot' ref={setParticipationEl} />
            )}
        </div>
    )
}

export default DeepAnalysisParticipationSection
